import type { Hex } from 'viem';
import { SignedMatchmakerABI } from '../generated/abi/signed-matchmaker';
import { SIGNED_MATCHMAKER_DOMAIN } from '../generated/eip712Meta';

interface AbiComponent {
  name: string;
  type: string;
  internalType?: string;
  components?: readonly AbiComponent[];
}

function abiComponentsToEip712Types(
  components: readonly AbiComponent[],
  structName: string
): Record<string, { name: string; type: string }[]> {
  const types: Record<string, { name: string; type: string }[]> = {};
  types[structName] = components.map((c) => {
    if (c.type === 'tuple' && c.internalType?.startsWith('struct ')) {
      const nested = c.internalType.replace('struct ', '');
      if (c.components) Object.assign(types, abiComponentsToEip712Types(c.components, nested));
      return { name: c.name, type: nested };
    }
    if (c.type === 'tuple[]' && c.internalType?.startsWith('contract ')) {
      return { name: c.name, type: 'address[]' };
    }
    if (c.internalType?.startsWith('contract ')) {
      return { name: c.name, type: c.type };
    }
    return { name: c.name, type: c.type };
  });
  return types;
}

const startGameFn = SignedMatchmakerABI.find(
  (item) => item.type === 'function' && item.name === 'startGame'
);
const battleOfferComponents = startGameFn?.inputs?.[0]?.components;
if (!battleOfferComponents) {
  throw new Error('SignedMatchmaker.startGame ABI missing BattleOffer components');
}

export const BATTLE_OFFER_EIP712_TYPES = abiComponentsToEip712Types(
  battleOfferComponents,
  'BattleOffer'
);
// openSeatsMask is a signed field but travels as a separate startGame param, so the
// ABI struct derivation can't see it; it hashes as the last word (see BATTLE_OFFER_TYPEHASH).
BATTLE_OFFER_EIP712_TYPES['BattleOffer'].push({ name: 'openSeatsMask', type: 'uint8' });

export function signedMatchmakerDomain(chainId: number, verifyingContract: Hex) {
  return {
    ...SIGNED_MATCHMAKER_DOMAIN,
    chainId,
    verifyingContract,
  } as const;
}
